import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminSubscriptions() {
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api.get("/admin/subscriptions").then((r) => setSubs(r.data));
  }, []);

  const total = subs.filter((s) => s.status === "active").reduce((sum, s) => sum + (s.amount || 0), 0);

  return (
    <div data-testid="admin-subscriptions-page">
      <h1 className="text-3xl font-black tracking-tighter mb-1" style={{ fontFamily: "Outfit" }}>Subscriptions</h1>
      <p className="text-[#888] text-sm mb-6">{subs.length} total subscriptions • ${total.toFixed(2)} active monthly</p>
      <div className="bg-[#0d0d0d] border border-white/5 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#080808] text-[#888] text-xs uppercase tracking-wider">
            <tr><th className="text-left p-3">Order ID</th><th className="text-left p-3">User ID</th><th className="text-left p-3">Plan</th><th className="text-left p-3">Amount</th><th className="text-left p-3">Status</th><th className="text-left p-3">Start</th><th className="text-left p-3">End</th></tr>
          </thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id} className="border-t border-white/5 hover:bg-white/5">
                <td className="p-3 font-mono text-xs">{s.paypalOrderId}</td>
                <td className="p-3 text-[#aaa] font-mono text-xs">{s.userId.slice(0, 8)}...</td>
                <td className="p-3 capitalize">{s.plan}</td>
                <td className="p-3">${s.amount?.toFixed(2)}</td>
                <td className="p-3">
                  <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${s.status === "active" ? "bg-[#00C853]/20 text-[#00C853]" : "bg-white/10 text-[#aaa]"}`}>{s.status.toUpperCase()}</span>
                </td>
                <td className="p-3 text-xs text-[#aaa]">{new Date(s.startDate).toLocaleDateString()}</td>
                <td className="p-3 text-xs text-[#aaa]">{new Date(s.endDate).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {subs.length === 0 && <div className="py-12 text-center text-[#888]">No subscriptions yet.</div>}
      </div>
    </div>
  );
}
